import createAsyncActions from 'shared/redux/helpers/create-async-actions';
import vodAdapter from 'shared/utils/adapters/vod';

import { normalizeArrayOfVideos } from 'shared/redux/helpers/normalized';


const ACTIONS = createAsyncActions('SERVER.CHANNEL.VIDEOS.LIST');
export const NAMES = ACTIONS.NAMES;
const { START, SUCCESS, FAIL } = ACTIONS;


function getVideos(method, id, options = {}) {

  options = _.merge(
    {
      sort: { order: 'custom', direction: 'asc' },
      paging: { size: 1000 },
    },
    options
  );

  return function (dispatch) {
    const params = { id, options };
    dispatch(START(params));

    const promise = vodAdapter.listItems[method](id, options);

    return promise
      .then(
        function (response) {
          response = {
            ...response,
            data: normalizeArrayOfVideos(response.data),
          };

          dispatch(SUCCESS(params, response));
          return response;
        },

        function (response) {
          dispatch(FAIL(params, response, { analytics: { type: 'error', name: 'shared.channel.videos.list' } }));
        }
      );
  };
}


export default _.partial(getVideos, 'list');

export const listPublic = _.partial(getVideos, 'listPublic');



// WEBPACK FOOTER //
// ./src/shared/redux/server/actions/channel/videos/list.js